import { Redirect } from 'expo-router';

import { useAuthStore } from '@/stores/useAuthStore';
import { useOnboardingStore } from '@/stores/useOnboardingStore';

const Index = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const isOnboardingCompleted = useOnboardingStore((state) => state.isCompleted);
  const isOnboardingSkipped = useOnboardingStore((state) => state.isSkipped);
  const isOnboardingLoading = useOnboardingStore((state) => state.isLoading);

  if (isLoading || isOnboardingLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Redirect href="./(auth)/login" />;
  }

  if (!isOnboardingCompleted && !isOnboardingSkipped) {
    return <Redirect href="./(onboarding)/welcome" />;
  }

  return <Redirect href="./meetings" />;
};

export default Index;
